
import { apiUrl } from "../ui-utils/apiConfig"
import { httpRequest } from "../ui-utils/api"

export const callTransferDepartmentInfo = async (dispatch) => {

    try {
        const departmentData = await httpRequest({
            endPoint: `${apiUrl.departmentList}`,
            method: "get",
            instance: "instanceOne",
        })

        if (departmentData.success) {
            const filteredData = departmentData.result.msg.map(item => ({
                sip_id: item.sip_group_id,
                departmentName: item.name,
                uid: item.uid
            }))

            dispatch({
                type: 'SET_DEP_USER_DATA',
                payload: filteredData
            })
        }
        // Dev Srini 25/10/24
        else{
            console.log('Error in Department List API', departmentData)
        }
    }
    catch (error) {
        console.log('Error in Department List API', error)
    }
}

export const callTransferAgentInfo = async (dispatch) => {
    try {
        const result = await httpRequest({

            endPoint: `${apiUrl.userList}`,
            method: "get",
            instance: "instanceOne",
        })

        if (result.success) {
            dispatch({
                type: 'SET_DEP_USER_DATA',
                payload: result.date
            })
        }
        else{
            console.log('Error in User List API', result)
        }
    }
    catch (error) {
        console.log('Error in User List API', error)
    }
}